const Badge = ({ content, children }) => {
  return (
    <div className="badge-container">
      {children}
      {content ? <span className="badge">{content}</span> : null}
    </div>
  );
};

export default Badge;
